import { render, staticRenderFns } from "./AlterarSenha.vue?vue&type=template&id=47856052&scoped=true&"
import script from "./AlterarSenha.vue?vue&type=script&lang=js&"
export * from "./AlterarSenha.vue?vue&type=script&lang=js&"
import style0 from "./AlterarSenha.vue?vue&type=style&index=0&id=47856052&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47856052",
  null
  
)

export default component.exports